import { render, staticRenderFns } from "./FormCheckPrice.vue?vue&type=template&id=2f8fd0c5&"
import script from "./FormCheckPrice.vue?vue&type=script&lang=js&"
export * from "./FormCheckPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports